// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ac-lazyLoadImg img {\n  max-width: 100%;\n  height: auto;\n}\n", "",{"version":3,"sources":["webpack://./src/components/UI/Image/styles.less"],"names":[],"mappings":"AAAA;EAEI,eAAA;EACA,YAAA;AAAJ","sourcesContent":[".ac-lazyLoadImg {\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
